// === GENERATED FILE ===
// DO NOT EDIT DIRECTLY, EDIT sh-toggle.lit.scss INSTEAD!
import { css } from 'lit-element';
export default css`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-toggle-height=1.25rem] - toggle height
   */
  --sh-toggle-height: 1.25rem;
  /* 
   * @cssprop [--sh-toggle-border-radius=0.625rem] - border radius
   */
  --sh-toggle-border-radius: 0.625rem;
  /* 
   * @cssprop [--sh-toggle-border-width=0.125rem] - border width
   */
  --sh-toggle-border-width: 0.125rem;
  /* 
   * @cssprop [--sh-toggle-circle-dimension=0.875rem] - toggle circle width and height
   */
  --sh-toggle-circle-dimension: 0.875rem;
  /* 
   * @cssprop [--sh-toggle-width=2.5rem] - toggle width
   */
  --sh-toggle-width: 2.5rem;
  /* 
   * @cssprop [--sh-toggle-margin=0.125rem 0.625rem 0.125rem 0.125rem] - toggle margin
   */
  --sh-toggle-margin: 0.125rem 0.625rem 0.125rem 0.125rem;
  /* 
   * @cssprop [--sh-toggle-circle-top=0.0625rem] - toggle circle top
   */
  --sh-toggle-circle-top: 0.0625rem;
  /* 
   * @cssprop [--sh-toggle-circle-left=0.0625rem] - toggle circle left
   */
  --sh-toggle-circle-left: 0.0625rem;
  /* 
   * @cssprop [--sh-toggle-active-left=1.25rem] - toggle circle left
   */
  --sh-toggle-active-left: 1.25rem;
  /* 
   * @cssprop [--sh-toggle-line-height=1.5rem] - toggle line height
   */
  --sh-toggle-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-toggle-label-line-height=1.5rem] - label line height
   */
  --sh-toggle-label-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-toggle-label-padding=0rem] - label padding
   */
  --sh-toggle-label-padding: 0rem;
}

:host {
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: fit-content;
  min-height: -ms-fit-content;
  min-height: -moz-fit-content;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  font: var(--body-1);
  color: var(--text-primary);
  line-height: var(--sh-toggle-line-height);
  outline: 0;
  cursor: pointer;
  height: fit-content;
  position: relative;
}

.toggle {
  height: var(--sh-toggle-height);
  min-width: var(--sh-toggle-width);
  border-radius: var(--sh-toggle-border-radius);
  margin: var(--sh-toggle-margin);
  border: var(--sh-toggle-border-width) solid rgba(var(--ui-1), var(--opacity-4));
  box-sizing: border-box;
  position: relative;
  transition: var(--transition-time) all ease-in-out;
  cursor: pointer;
}

.toggle-label {
  display: block;
  width: calc(100% - var(--sh-toggle-width));
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: var(--sh-toggle-label-line-height);
  padding: var(--sh-toggle-label-padding);
}

.toggle::before {
  position: absolute;
  left: var(--sh-toggle-circle-left);
  top: var(--sh-toggle-circle-top);
  height: var(--sh-toggle-circle-dimension);
  width: var(--sh-toggle-circle-dimension);
  content: "";
  background: rgba(var(--ui-1), var(--opacity-3));
  border-radius: 50%;
  transition: var(--transition-time) all ease-in-out;
}

:host([active]) .toggle {
  background-color: rgba(var(--ui-2), var(--opacity-1));
  border-color: transparent;
}

:host([active]) .toggle::before {
  background: white;
  left: var(--sh-toggle-active-left);
}

:host([active][disabled]) .toggle {
  opacity: 0.2;
}

:host([active][neutral]) .toggle {
  background-color: rgba(var(--ui-1), var(--opacity-4));
}

:host([disabled]) {
  cursor: default;
  pointer-events: none;
  color: rgba(var(--ui-1), var(--opacity-5));
}

:host([disabled]:not([active])) .toggle {
  border-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([disabled]:not([active])) .toggle::before {
  background: rgba(var(--ui-1), var(--opacity-5));
}

/* hover */
:host(:not(.touch-device):not([active]):hover) .toggle {
  border-color: rgba(var(--ui-1), var(--opacity-3));
}

:host(:not(.touch-device)[active]:hover) .toggle {
  background: rgba(var(--ui-3), var(--opacity-1));
}

:host(:not(.touch-device)[active][neutral]:hover) .toggle {
  background: rgba(var(--ui-1), var(--opacity-3));
}

:host(:not(.touch-device):not([active]):hover) .toggle::before {
  background: rgba(var(--ui-1), var(--opacity-2));
}

/* focus */
.item-focused {
  outline: var(--focus-outline);
}`;